'use client';

import { useEffectOnce } from 'react-use';

import scheduleIdleAfterLCP from '@/commons/scheduleIdleAfterLCP';
import ensurePostHogClientInitialized from './ensurePostHogClientInitialized';
import getClientShouldUseCookielessMode from './getClientShouldUseCookielessMode';
import handlePostHogInitError from './handlePostHogInitError';

const PostHogDeferredInit = () => {
  useEffectOnce(() => {
    const cancel = scheduleIdleAfterLCP(() => {
      ensurePostHogClientInitialized({
        shouldUseCookielessMode: getClientShouldUseCookielessMode(),
      }).catch(handlePostHogInitError);
    });

    return cancel;
  });

  return null;
};

export default PostHogDeferredInit;
